import React from 'react';
import { Button, Checkbox, notification, Form, type FormProps, Input, Card, Select, DatePicker, InputNumber, Upload } from 'antd';
import { CouponService } from "./../../services/CouponService";
// import 'ckeditor5/ckeditor5.css';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import { ClassicEditor, Essentials, Paragraph, Bold, Italic, List } from 'ckeditor5';


interface Props {
    record: {
        id: number
        coupon: {
            expired_date: string
            id: number
            name: string
            start_date: string
        }
    }
    onFinish: () => void
}

export default function AddCouponCode(props: Props) {


    const [form] = Form.useForm();



    const onFinish: FormProps["onFinish"] = async (values) => {


        const data = {
            id: props?.record?.id,
            code: values.code
        }

        var res = await CouponService.assignCouponCode(data)
        form.resetFields();

        if (res?.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            props.onFinish();
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    };

    const onFinishFailed: FormProps["onFinishFailed"] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    return (
        <Card
            title={'Add Coupon Code'}
            bordered={false}>

            <Form
                name="basic"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{
                    code: '',
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >

                <Form.Item
                    label="Coupon Id"
                    name="coupon_id"
                    rules={[{ required: false, message: 'Please fill coupon id' }]}
                >
                    {props?.record?.coupon?.id}
                </Form.Item>

                <Form.Item
                    label="Coupon Name"
                    name="coupon_name"
                    rules={[{ required: false, message: 'Please fill coupon name' }]}
                >
                    {props?.record?.coupon?.name}
                </Form.Item>

                <Form.Item
                    label="Code"
                    name="code"
                    rules={[{ required: true, message: 'Please fill coupon code' }]}
                >
                    <Input />
                </Form.Item>




                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit">
                        {props.record?.id ? 'อัพเดต' : 'บันทึก'}
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}
